var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebchatDesativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5068 7H11.5023C9.01701 7 7 9.008 7 11.4842V16.8689V17.7694C7 20.2456 9.01701 22.2536 11.5023 22.2536H12.8529C13.096 22.2536 13.4202 22.4157 13.5733 22.6138L14.924 24.4057C15.5183 25.1981 16.4907 25.1981 17.085 24.4057L18.4357 22.6138C18.6068 22.3887 18.8769 22.2536 19.1561 22.2536H20.5068C22.992 22.2536 25.009 20.2456 25.009 17.7694V11.4842C25.009 9.008 22.992 7 20.5068 7ZM12.4027 16.0045C11.8984 16.0045 11.5023 15.5993 11.5023 15.1041C11.5023 14.6088 11.9075 14.2036 12.4027 14.2036C12.8979 14.2036 13.3032 14.6088 13.3032 15.1041C13.3032 15.5993 12.907 16.0045 12.4027 16.0045ZM16.0045 16.0045C15.5002 16.0045 15.1041 15.5993 15.1041 15.1041C15.1041 14.6088 15.5093 14.2036 16.0045 14.2036C16.4997 14.2036 16.905 14.6088 16.905 15.1041C16.905 15.5993 16.5088 16.0045 16.0045 16.0045ZM19.6063 16.0045C19.102 16.0045 18.7059 15.5993 18.7059 15.1041C18.7059 14.6088 19.1111 14.2036 19.6063 14.2036C20.1015 14.2036 20.5068 14.6088 20.5068 15.1041C20.5068 15.5993 20.1106 16.0045 19.6063 16.0045Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebchatDesativo);
export default __webpack_public_path__ + "static/media/Webchat-Desativo.e3e9d6f5.svg";
export { ForwardRef as ReactComponent };